import {
  FETCH_ROLES,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  CREATE_ROLES,
  CREATE_ROLES_SUCCESS,
  CREATE_ROLES_FAILURE,
} from "./actionTypes";

const initialState = {
  roles: [],
  loading: false,
  error: null,
  success:false
};

const rolesReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case FETCH_ROLES:
      return { ...state, loading: true,success:false };
    case FETCH_ROLES_SUCCESS:
      return { ...state, loading: false, roles: action.payload.data,success:false};
    case FETCH_ROLES_FAILURE:
      return { ...state, loading: false, error: action.payload,success:false };
       case CREATE_ROLES:
            return { ...state, loading: true,success:false };
          case CREATE_ROLES_SUCCESS:
            return {
              ...state, loading: false, success:true, role: action.payload, error: null };
          case CREATE_ROLES_FAILURE:
            return { ...state, loading: false, success:false, error: action.payload };
    default:
      return state;
  }
};

export default rolesReducer;
